import {
  React,
  Component,
  PropTypes,
} from 'imports/CommonImports';

import {
  GreyColor1,
  GreyColor2,
  SuccessColorLight,
  PrimaryColor1,
  ShadowColor,
} from 'imports/DesignImports';

import {
  Paper,
} from 'material-ui';

import ReactHighcharts from 'react-highcharts';

const styles = {
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '20em',
  },
  header: {
    marginLeft: '1em',
  },
}

class ProjectDistributionGraph extends Component {
  state = {
    now: new Date(Date.now()),
    colors: [SuccessColorLight,  PrimaryColor1, GreyColor1, ShadowColor,],
  }

  render() {
    return (
      <Paper style={{...styles.paper, ...this.props.style}}>
        <div style={styles.headerContainer}>
          <p style={styles.header}><b>{this.props.title}</b></p>
        </div>
        <ReactHighcharts config={this.config} ref="chart" style={{minHeight:"400px"}}/>
      </Paper>
    );
  }

  config = {
    chart: {
        type: 'area',
        backgroundColor: GreyColor2,
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: [this.state.now.getFullYear() - 1, this.state.now.getFullYear(), this.state.now.getFullYear() + 1],
        tickmarkPlacement: 'on',
        title: {
            enabled: false
        }
    },
    yAxis: {
        title: {
            text: this.props.indicator + ' (MM ' + this.props.currency + ')',
        },
        labels: {
            formatter: function () {
                return this.value / 1000;
            }
        }
    },
    tooltip: {
        valueSuffix: ' ' + this.props.currency,
    },
    plotOptions: {
        area: {
            stacking: 'normal',
            lineColor: '#666666',
            lineWidth: 1,
            marker: {
                lineWidth: 1,
                lineColor: '#666666'
            },
            // dataLabels: {
            //   enabled: true,
            //   color: (ReactHighcharts.theme && ReactHighcharts.theme.dataLabelsColor) || 'white',
            //   align: 'right',
            //   allowOverlap: true,
            // },
        },
    },
    series: this.props.data.map((data) => {return {name: data.name, data: data.values}}),
  }
}

ProjectDistributionGraph.propTypes = {
  style: PropTypes.object,
  title: PropTypes.string,
  data: PropTypes.array,
  indicator: PropTypes.string,
  currency: PropTypes.string,
}

ProjectDistributionGraph.defaultProps = {
  style: {},
  title: 'Distribución del aporte económico por proyecto',
  data: [
      {name: 'Digitalización de procesos financieros', values: [100, 200, 300]},
      {name: 'Producción en seco de fruta', values: [200, 300, 400]},
      {name: 'Riego automatizado para campos en pendiente', values: [300, 400, 500]},
    ],
  indicator: 'EBITDA',
  currency: 'CLP',
}
export default ProjectDistributionGraph;



// WEBPACK FOOTER //
// ./src/components/dashboard/ProjectDistributionGraph.js